export const DEFAULT_CHAT_WIDTH = 416;
export const MIN_CHAT_WIDTH = 280;
export const MAX_CHAT_WIDTH = 720;
export const CHAT_RESIZE_STEP = 24;

export function clampChatWidth(width: number): number {
  return Math.min(MAX_CHAT_WIDTH, Math.max(MIN_CHAT_WIDTH, width));
}

export function nextChatWidthFromDrag(
  startWidth: number,
  startX: number,
  currentX: number
): number {
  return clampChatWidth(startWidth + (startX - currentX));
}

export function nextChatWidthFromKey(currentWidth: number, key: string): number | undefined {
  if (key === 'ArrowLeft') {
    return clampChatWidth(currentWidth + CHAT_RESIZE_STEP);
  }
  if (key === 'ArrowRight') {
    return clampChatWidth(currentWidth - CHAT_RESIZE_STEP);
  }
  return undefined;
}
